import React from 'react';
import Spinner from '../Spinner';

export default () => (
  <div className="search-spinner">
    <p>Loading results ... </p>
    <Spinner />
  </div>
);
